class Stripe {
  constructor({ id }) {
    this.id = id;
  }
}

export default Stripe;
